var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4545 3.90128C25.4749 3.90128 32 9.12601 32 15.5478C32 22.6998 24.5178 27.1275 17.5855 27.1275C14.768 27.1275 12.6633 26.55 11.1942 26.1907C9.73964 27.0824 8.87564 27.6991 4.98036 28.838C5.75855 26.8409 6.03055 24.8409 5.85455 22.6344C4.63709 21.1798 2.90909 19.1435 2.90909 15.5478C2.90909 9.12601 9.43418 3.90128 17.4545 3.90128ZM17.4545 0.992188C8.23564 0.992188 0 7.1391 0 15.5478C0 18.5296 1.07491 21.4576 2.97745 23.7296C3.05745 26.3915 1.48945 30.2111 0.0785455 32.9922C3.86327 32.3086 9.24364 30.7987 11.6829 29.3035C13.744 29.8053 15.7178 30.0351 17.5869 30.0351C27.8909 30.0351 34.9105 22.9995 34.9105 15.5464C34.9091 7.09401 26.6167 0.992188 17.4545 0.992188Z",
    fill: "#E86247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentRed);
export default __webpack_public_path__ + "static/media/comment-red.a75ae3a9ecf2b353704e86e7b0923e61.svg";
export { ForwardRef as ReactComponent };